import {
  DeleteTwoTone,
  DownloadOutlined,
  EditOutlined,
  FilterOutlined,
  PlusOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import {
  Button,
  Checkbox,
  Col,
  Input,
  InputRef,
  notification,
  Row,
  Select,
  Skeleton,
  Space,
  Table,
  TableColumnType,
  Tooltip,
} from "antd";
import React, { Key, useEffect, useRef, useState } from "react";
import type { ColumnsType } from "antd/es/table";

import { useClient } from "../../Context/ClientContext";
import { useLocation } from "react-router-dom";
import { useTheme } from "../../Context/ThemeContext";
import "../../Common/Acc_Common.css";
import search from "../../Images/search.svg";
import InvoiceExportService from "../../Services/InvoiceExportDetails";
import {
  FilterDropdownProps,
  TableRowSelection,
} from "antd/es/table/interface";
import { ConfirmationModal } from "../../Common/ConfirmationModal";
import { notificationContext } from "../../Common/PageRoute";
import {
  TextSearchTableEnum,
  TextSearchTableOption,
} from "../../Common/SearchTableOptions";
import AddCustomerRoles1 from "./AddCustomerRoles";
import { useUser } from "../../../Context/UserContext";
import CustomerRoleServices, {
  DBRecordStatusRole,
} from "../../Services/CustomerRoleServices";
import { ClientPremissions } from "./UserPermissionCommonData";
import ClientRoleServices from "../../Services/ClientRoleServices";
import AddClientRoles from "./AddClientRoles";

interface IRoleListData {
  key: string;
  sno: number;
  id: string;
  name: string;
  number: string;
  description: string;
  ItemStatus: DBRecordStatusRole;
  customerId?: string;
}

const RoleTable: React.FC<{ clientId?: string }> = (props) => {
  type DataIndex = keyof IRoleListData;
  const { getUserId } = useUser();

  const userId = getUserId();
  const searchInput = useRef<InputRef>(null);
  const searchSelect = useRef<any>(null);
  const [openDropdown, setOpenDropdown] = useState<DataIndex | null>(null);

  const { themeData } = useTheme();
  const location = useLocation();
  const [openModel, setOpenModel] = useState<any>({
    type: "",
    param: {},
  });
  const [rolesList, setRolesList] = useState<IRoleListData[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [trigger, setTrigger] = useState<boolean>(false);
  const [pageSize, setPageSize] = useState<number>(15);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [page, setPage] = useState(1);
  const [searchItem, setSearchItem] = useState<string>("");
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  // const [isService, setIsServices] =useState<string>();
  // const [gstRate, setGstRate] = useState<any[]>([]);
  const [width, setWidth] = useState<any>(window.innerWidth);
  const [filter, setfilter] = useState<any>({
    sortCol: "",
    sortDir: "",
  });
  const [exportItemsData, setExportItemsData] = useState<any>([]);
  const [exportType, setExportType] = useState<number>(-1);
  const [roleStatus, setRoleStatus] = useState<DBRecordStatusRole>(
    DBRecordStatusRole.Active
  );
  const [searchColumns, setSearchColumns] = useState<any>({
    name: "",
    Description: "",
    purchasePrice: "",
  });
  const [searchColumnCount, setSearchColumnCount] = useState<number>(0);
  const [searchColumnsDropDown, setSearchColumnsDropDown] = useState<{
    nameDropEnum: TextSearchTableEnum;
    descriptionDropEnum: TextSearchTableEnum;
  }>({
    nameDropEnum: TextSearchTableEnum.contains,
    descriptionDropEnum: TextSearchTableEnum.contains,
  });

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [width]);

  // Get list useEffect
  useEffect(() => {
    // setLoading(true);
    if (userId && (exportType === -1 || exportType)) {
      const requestModel = {
        name: searchColumns.name,
        nameDropEnum: searchColumnsDropDown.nameDropEnum,
        number: searchColumns.number,
        descriptionDropEnum: searchColumnsDropDown.descriptionDropEnum,
      };
      getList(
        userId,
        exportType >= 1 ? 0 : (page - 1) * pageSize,
        exportType >= 1 ? 0 : pageSize,
        filter.sortCol,
        filter.sortDir,
        searchItem,
        roleStatus,
        requestModel
      );
    } else if (userId === null) {
      console.error("Invalid user");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    trigger,
    page,
    pageSize,
    searchItem,
    location.pathname,
    filter.sortCol,
    filter.sortDir,
    exportType,
    searchColumns,
    roleStatus,
  ]);
  // --------- Get List TableData API ---------
  const getList = async (
    userId: string,
    start: number,
    length: number,
    sortCol?: string,
    sortDir?: string,
    search?: string,
    status?: any,
    requestModel?: any
  ) => {
    // debugger;
    if (exportType < 1) {
      setLoading(true);
    }
    try {
      const res = props.clientId
        ? await ClientRoleServices.getRoleList(
            props?.clientId,
            start,
            length,
            sortCol,
            sortDir,
            search,
            status,
            requestModel
          )
        : await CustomerRoleServices.getRoleList(
            userId,
            start,
            length,
            sortCol,
            sortDir,
            search,
            status,
            requestModel
          );

      console.log("res", res);
      if (res.items.length > 0) {
        let ItemsData = res?.items?.map((v: any, i: any) => {
          return {
            key: i,
            sno: v?.sno,
            id: v?._id,
            name: v?.name,
            description: v?.description,
            ItemStatus: v?.status,
            customerId: v?.customerId,
            // hsnSacCode: v?.hsnSacCode,
          };
        });

        if (exportType >= 1) {
          setExportItemsData(ItemsData);
          if (exportType === 1) {
            exportCsv(ItemsData);
          } else if (exportType === 2) {
            // exportPDF(ItemsData);
          } else if (exportType === 3) {
            // exportExcel(ItemsData);
          }
        } else {
          console.log("data", ItemsData)
          setRolesList(ItemsData);
          setTotalRecords(res?.totalRecords);
        }
        setTotalRecords(res?.totalRecords);
        // console.log("table,,,,,,,,,,,", props.trigger);
      } else if (res.items.length === 0) {
        setRolesList([]);
        setTotalRecords(res?.totalRecords);
      }
    } catch (ex: any) {
      console.error(ex.message);
      setRolesList([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const handleKeyDown = (e: any) => {
      console.log("useEffect", e.shiftKey);

      if (e.shiftKey && e.key === "I") {
        setOpenModel({
          type: props.clientId ? "addClientRole" : "addRole",
          param: { open: true },
        });
      }
      if (e.altKey) {
        if (e.shiftKey && e.key.toLowerCase() === "c") {
          setOpenModel({ type: "", param: "" });
        }
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const handleSearch = (
    selectedKeys: string[] | any,
    confirm: any,
    dataIndex: DataIndex
  ) => {
    let prevValue = searchColumns[dataIndex];
    let newValue = selectedKeys;

    // console.log("newValue", prevValue, newValue);
    if (newValue?.length < 0) {
      confirm();
      setOpenDropdown(null);
      return;
    }

    let newSearchColumns = { ...searchColumns };
    switch (dataIndex) {
      case "name":
      case "number":
        newSearchColumns[dataIndex] = selectedKeys[0];
        break;
    }

    if (!prevValue && newValue?.length > 0) {
      setSearchColumnCount((prev) => prev + 1);
    }

    setSearchColumns(newSearchColumns);
    // console.log(searchColumnCount, "count", prevValue, newValue, selectedKeys);
    confirm();
    setOpenDropdown(null); // Close the dropdown
  };

  const handleDropdownText = (
    dataIndex: DataIndex,
    valDropDown: TextSearchTableEnum
  ) => {
    switch (dataIndex) {
      case "name":
        setSearchColumnsDropDown({
          ...searchColumnsDropDown,
          nameDropEnum: valDropDown,
        });
        break;
      case "description":
        setSearchColumnsDropDown({
          ...searchColumnsDropDown,
          descriptionDropEnum: valDropDown,
        });
        break;
    }
  };

  const handleReset = (
    clearFilters: () => void,
    confirm: FilterDropdownProps["confirm"],
    dataIndex: DataIndex
  ) => {
    clearFilters();
    confirm();

    let prevValue = searchColumns[dataIndex];

    if (prevValue) {
      setSearchColumnCount((prev) => prev - 1);
    }
    if (prevValue) {
      setSearchColumns((prev: any) => {
        const newSearchColumns = { ...prev };
        delete newSearchColumns[dataIndex];
        return newSearchColumns;
      });
    }
  };

  const getColumnSearchProps = (
    dataIndex: DataIndex,
    searchPlaceHolder?: string
  ): TableColumnType<IRoleListData> => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Select
          defaultValue={TextSearchTableEnum.contains}
          style={{
            width: "100%",
            maxWidth: "200px",
            marginBottom: "8px",
          }}
          onChange={(val: TextSearchTableEnum) => {
            setExportItemsData([]);
            handleDropdownText(dataIndex, val);
            // setTextTypeSearchColumn(val);
            // setType(1);
          }}
          options={TextSearchTableOption?.map((x: any) => ({
            value: x.value,
            label: x.label,
          }))}
        />
        <Input
          ref={searchInput}
          placeholder={`Search.. ${searchPlaceHolder}`}
          value={selectedKeys[0]}
          onChange={(e) => {
            setSelectedKeys(e.target.value ? [e.target.value] : []);
          }}
          onPressEnter={() =>
            handleSearch(selectedKeys as string[], confirm, dataIndex)
          }
          style={{ marginBottom: 8, display: "block", width: "200px" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() =>
              handleSearch(selectedKeys as string[], confirm, dataIndex)
            }
            size="small"
            style={{ width: 95 }}
          >
            Search
          </Button>
          <Button
            onClick={() => {
              clearFilters && handleReset(clearFilters, confirm, dataIndex);
            }}
            size="small"
            style={{ width: 95 }}
          >
            Clear
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered: boolean) =>
      searchPlaceHolder ? (
        <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
      ) : (
        <FilterOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
      ),
    filterDropdownOpen: openDropdown === dataIndex,
    filterDropdownProps: {
      placement: "bottomLeft",
    },
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setOpenDropdown(dataIndex);
        setTimeout(() => {
          searchInput.current?.select(); // Use select for Input component
        }, 100);
      } else {
        setOpenDropdown(null);
      }
    },
  });

  // --------- Table Columns  ---------
  const columns: ColumnsType<IRoleListData> = [
    {
      title: "S.No.",
      dataIndex: "sno",
      key: "sno",
      render: (_, record) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {record?.sno}
        </Skeleton>
      ),
    },
    {
      title: "Role",
      dataIndex: "name",
      key: "Role",
      sorter: true,
      width: "30%",
      defaultSortOrder: "descend",
      filteredValue: searchColumns.name ? [searchColumns.name] : null,
      onFilter: (value: any, record) => true,
      render: (_, record) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          <>{record?.name}</>
        </Skeleton>
      ),
      ...getColumnSearchProps("name", "Role"),
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      width: "40%",
      sorter: true,
      filteredValue: searchColumns.description
        ? [searchColumns.description]
        : null,
      render: (_, record) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {record?.description}
        </Skeleton>
      ),
      ...getColumnSearchProps("description", "Description"),
    },
    {
      title: "Active",
      dataIndex: "",
      key: "active",
      render: (_, record) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          <Tooltip
            title={
              record?.customerId || props.clientId
                ? record?.ItemStatus === DBRecordStatusRole.Active
                  ? "In-Active"
                  : "Active"
                : ""
            }
            placement="top"
            color="#3D4998"
          >
            <Checkbox
              checked={record?.ItemStatus === DBRecordStatusRole.Active}
              disabled={!record?.customerId}
              onChange={(e: any) => {
                console.log(e.target.checked, record);

                setOpenModel({
                  type: "changeRole",
                  param: {
                    name: record.name,
                    id: record.id,
                    itemStatus:
                      record?.ItemStatus === DBRecordStatusRole.Active
                        ? DBRecordStatusRole.MarkAsDeleted
                        : DBRecordStatusRole.Active,
                  },
                });
              }}
            />
          </Tooltip>
        </Skeleton>
      ),
    },
    {
      title: "Action",
      dataIndex: "",
      key: "action",
      render: (_, record) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              {/* <Tooltip
                title={
                  record?.ItemStatus === DBRecordStatusRole.Active
                    ? "In-Active"
                    : "Active"
                }
                placement="top"
                color="#3D4998"
              >
                <Checkbox
                  checked={
                    record?.ItemStatus !== DBRecordStatusRole.MarkAsDeleted
                  }
                  onChange={(e: any) => {
                    console.log(e.target.checked, record);
                    setOpenModel({
                      type: "changeRole",
                      param: {
                        name: record.name,
                        id: record.id,
                        itemStatus: record?.ItemStatus,
                      },
                    });
                  }}
                />
              </Tooltip> */}
            </div>
            {(record?.customerId || props?.clientId) && (
              <>
                <div>
                  {record.ItemStatus === DBRecordStatusRole.Active ? (
                    <Tooltip title="Edit" placement="top" color="#3D4998">
                      <EditOutlined
                        // className="ca-edit-btn"
                        style={{ color: "#444653" }}
                        onClick={async () => {
                          setOpenModel({
                            type: props.clientId ? "addClientRole" : "addRole",
                            param: {
                              open: true,
                              id: record.id,
                            },
                          });
                        }}
                      />
                    </Tooltip>
                  ) : (
                    <></>
                  )}
                </div>
                <div>
                  <Tooltip title="Delete" placement="top" color="red">
                    <DeleteTwoTone
                      className="ca-delete-btn cursor"
                      twoToneColor="#ff879d"
                      onClick={() => {
                        setOpenModel({
                          type: "changeRole",
                          param: {
                            name: record?.name,
                            id: record?.id,
                            itemStatus: DBRecordStatusRole.Deleted,
                          },
                        });
                      }}
                    />
                  </Tooltip>
                </div>
              </>
            )}
          </div>
        </Skeleton>
      ),
    },
  ];

  //----- Table Ascending & Desending Order -----
  const tableSort = (pagination?: any, sort?: any, filter?: any) => {
    setfilter({
      sortCol: filter.column !== undefined ? filter.columnKey : "number",
      sortDir:
        filter.column !== undefined
          ? filter.order === "descend"
            ? "desc"
            : "asc"
          : "desc",
    });
    console.log("sort1111111111111", sort?.TaxRate?.Rate, sort);
  };

  // Table Download
  const onSelectChange = (newSelectedRowKeys: Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection: TableRowSelection<any> = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  // Get the selected row data
  const selectedRows = rolesList.filter((item) =>
    selectedRowKeys.includes(item.key)
  );

  let path = "Items List";

  const generateFooterRow = (columns: string[]) => {
    return columns.map((col) => "");
  };

  const columnsA = ["S.No.", "Name", "Description"];

  const fieldMapping = {
    "S.No.": (item: any) => item?.sno,
    Name: (item: any) => item?.name,
    Description: (item: any) => item?.description,
  };

  const exportCsv = (invExportDataa: any[]) => {
    const exportData =
      selectedRowKeys.length > 0 ? selectedRows : invExportDataa;
    InvoiceExportService.generateCSV(
      exportData,
      columnsA,
      fieldMapping,
      generateFooterRow,
      "",
      "",
      path
    );
    setExportType(0);
  };

  // const exportPDF = (invExportDataa: any[]) => {
  //   const exportData =
  //     selectedRowKeys.length > 0 ? selectedRows : invExportDataa;
  //   InvoiceExportService.generatePDF(
  //     exportData,
  //     columnsA,
  //     fieldMapping,
  //     generateFooterRow,
  //     "",
  //     path
  //   );
  //   setExportType(0);
  // };

  // const exportExcel = async (invExportDataa: any[]) => {
  //   const rowData = selectedRowKeys.length > 0 ? selectedRows : invExportDataa;
  //   await InvoiceExportService.generateExcel(
  //     rowData,
  //     columnsA,
  //     fieldMapping,
  //     generateFooterRow,
  //     "",
  //     path
  //   );
  //   setExportType(0);
  // };

  const content = (
    <Space direction="vertical">
      <div>
        <Button
          style={{ width: "80px" }}
          size="small"
          title="CSV"
          onClick={() => {
            if (exportItemsData.length > 0) {
              exportCsv(exportItemsData);
            } else {
              setExportType(1);
            }
          }}
          icon={<DownloadOutlined />}
        >
          CSV
        </Button>
      </div>

      <div>
        <Button
          style={{ width: "80px" }}
          size="small"
          title="PDF"
          onClick={() => {
            // if (exportItemsData.length > 0) {
            //   exportPDF(exportItemsData);
            // } else {
            //   setExportType(2);
            //   // setApiCallExports(true);
            // }
          }}
          icon={<DownloadOutlined />}
        >
          PDF
        </Button>
      </div>
      <div>
        <Button
          style={{ width: "80px" }}
          size="small"
          title="XLSX"
          onClick={() => {
            // if (exportItemsData.length > 0) {
            //   exportExcel(exportItemsData);
            // } else {
            //   setExportType(3);
            //   // setApiCallExports(true);
            // }
          }}
          icon={<DownloadOutlined />}
        >
          XLSX
        </Button>
      </div>
    </Space>
  );

  return (
    <>
      <Row
        justify="space-between"
        style={{
          // paddingTop: props?.partyId ? "10px" : "0px"
          // marginTop: 10,
          padding: "0px 0px 3px 0px",
        }}
        // style={{ position: "sticky",zIndex:1, top: 0, padding: "5px" }}
      >
        <Col>
          <Space>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => {
                setOpenModel({
                  type: props.clientId ? "addClientRole" : "addRole",
                  param: { open: true },
                });
              }}
            >
              Role
            </Button>

            {/* {rolesList?.length === 0 ? (
              <>
                <Button
                  type="default"
                  icon={<DownloadOutlined />}
                  // onClick={() => exportCsv()}
                  disabled
                >
                  Export
                </Button>
              </>
            ) : (
              <>
                <Popover content={content} placement="rightTop" trigger="hover">
                  <Button
                    type="default"
                    icon={<DownloadOutlined />}
                    // onClick={() => exportCsv()}
                  >
                    Export
                  </Button>
                </Popover>
              </>
            )} */}
          </Space>
        </Col>

        <Col
          style={{
            marginTop: width <= 768 ? 15 : "",
          }}
        >
          <Row gutter={width <= 768 ? 98 : 8}>
            <Col>
              <Input
                allowClear
                style={{ width: "200px", border: "1px solid #f1f3ff" }}
                placeholder="Search.."
                onChange={(e: any) => {
                  setLoading(true);
                  setExportItemsData([]);
                  if (!e.cancelable) {
                    //console.log("typeing user............");
                    const searchItem = setTimeout(() => {
                      setPage(1);
                      setSearchItem(e.target.value);
                    }, 1000);
                    return () => clearTimeout(searchItem);
                  } else {
                    // console.log("Click cancle............");
                    setSearchItem(e.target.value);
                  }
                }}
                suffix={
                  loading || searchItem ? (
                    ""
                  ) : (
                    <img alt="Search.." src={search} />
                  )
                }
              />
            </Col>

            <Col>
              <Select
                defaultValue={DBRecordStatusRole.Active}
                style={{ width: "110px" }}
                onSelect={(e: DBRecordStatusRole) => {
                  setRoleStatus(e);
                  setExportItemsData([]);
                  setPage(1);
                }}
                options={[
                  { value: DBRecordStatusRole.Active, label: "Active" },
                  {
                    value: DBRecordStatusRole.MarkAsDeleted,
                    label: "In-Active",
                  },
                  { value: DBRecordStatusRole.All, label: "All" },
                ]}
              />
            </Col>
          </Row>
        </Col>
      </Row>

      {/* --------- Table --------- */}

      <Table
        columns={columns}
        dataSource={
          loading
            ? (Array.from({ length: pageSize }, (_, index) => ({
                key: `loading-${index}`,
              })) as IRoleListData[])
            : rolesList
        }
        locale={{
          triggerDesc: "",
          triggerAsc: "",
          cancelSort: "",
        }}
        onChange={tableSort}
        className={`Tabel-style table-${themeData?.componentSize ?? "middle"}`}
        // rowSelection={rowSelection}
        pagination={{
          total: totalRecords,
          current: page,
          pageSize: pageSize,
          showSizeChanger: true,
          onChange: (page: number, pageSize: number) => {
            setPage(page);
            setPageSize(pageSize);
            setExportType(-1);
          },
          pageSizeOptions: ["10", "15", "25", "50", "100"],
          showTotal: (totalRecords, page) =>
            `${page[0]}-${page[1]} of ${totalRecords} items`,
        }}
        scroll={
          pageSize > 15 ? { x: 1000, y: window.innerHeight - 320 } : { x: 1000 }
        }
      />

      {/* --------- AddItem --------- */}
      {openModel.type === "addClientRole" && (
        <AddClientRoles
          open={true}
          onCancel={() => setOpenModel({ type: "", clientId: "" })}
          clientId={props?.clientId!}
          drawerPlacement="right"
          setTrigger={setTrigger}
          setAddNewClientRole={() => console.log()}
          id={openModel?.param.id}
        />
      )}

      {openModel.type === "addRole" && (
        <AddCustomerRoles1
          open={openModel?.param.open}
          onCancel={() => setOpenModel({ type: "", param: "" })}
          id={openModel?.param.id}
          // setTrigger={setTrigger((x) => !x)}
          setTrigger={setTrigger}
        />
      )}
      {openModel.type === "changeRole" && (
        <ConfirmationModal
          open={true}
          onNo={() => setOpenModel({ type: "", param: "" })}
          onYes={async () => {
            try {
              const changeRole = props.clientId
                ? await ClientRoleServices.changeRoleStatus(
                    props.clientId!,
                    openModel?.param?.id,
                    openModel.param?.itemStatus
                  )
                : await CustomerRoleServices.changeRoleStatus(
                    userId!,
                    openModel?.param?.id,
                    openModel.param?.itemStatus
                  );
              // console.log("changeRole", changeRole);
              if (changeRole.result) {
                notification.success({
                  message: `Role "${openModel?.param?.name}"  ${
                    openModel?.param?.itemStatus === DBRecordStatusRole.Deleted
                      ? "Delete"
                      : openModel?.param?.itemStatus ===
                        DBRecordStatusRole.Active
                      ? "Active"
                      : "InActive"
                  } sucessfully.`,
                });

                setTrigger((x) => !x);
                setOpenModel({ type: "", param: "" });
              } else {
                notification.error({
                  message: changeRole?.message,
                });
                console.log("error", changeRole?.message);
                setOpenModel({ type: "", param: "" });
              }
            } catch (err: any) {
              notification.error({
                message: err,
              });
              console.log("error", err);
              setOpenModel({ type: "", param: "" });
            }
          }}
          text={`Are you sure you want to ${
            openModel?.param?.itemStatus === DBRecordStatusRole.Deleted
              ? "Delete"
              : openModel?.param?.itemStatus === DBRecordStatusRole.Active
              ? "Active"
              : "InActive"
          } this "${openModel?.param?.name}" Role. ?`}
        />
      )}

      {/* Active / InActive ConfirmationModel */}
      {/* {openModel.type === "changeRole1" && (
        <ConfirmationModal
          open={true}
          onNo={() => setOpenModel({ type: "", param: "" })}
          onYes={async () => {
            try {
              const apiData = 
              await ItemsServices.isActiveItem(
                userId!,
                openModel.param?.id,
                openModel.param?.itemStatus === DBRecordStatusRole.MarkAsDeleted
                  ? DBRecordStatusRole.Active
                  : DBRecordStatusRole.MarkAsDeleted
              );
              if (apiData.result) {
                openNotification(
                  "success",
                  `Item "${openModel?.param?.name}" ${
                    openModel?.param?.itemStatus ===
                    DBRecordStatusRole.MarkAsDeleted
                      ? "Active"
                      : "InActive"
                  } sucessfully.`
                );

                setTrigger((x) => !x);
                setOpenModel({ type: "", param: "" });
              } else {
                openNotification("error", apiData?.message);
                console.log("error", apiData?.message);
                setOpenModel({ type: "", param: "" });
              }
            } catch (err) {
              openNotification("error", err);
              console.log("error", err);
              setOpenModel({ type: "", param: "" });
            }
          }}
          text={`Are you sure you want to ${
            openModel?.param?.itemStatus === DBRecordStatusRole.MarkAsDeleted
              ? "Active"
              : "InActive"
          }  this "${openModel?.param?.name}" Item. ?`}
        />
      )} */}
    </>
  );
};

export default RoleTable;
